// Polyfill to allow us to use the "smooth" behavior when using scrollIntoView
// https://github.com/iamdustan/smoothscroll
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

// polyfill for remove() method in Internet Explorer 9 and higher
// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function(arr) {
  arr.forEach(item => {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null) this.parentNode.removeChild(this);
      },
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// polyfill for element.closest to support ie11
// https://github.com/jonathantneal/closest
// we import this here because for some reason our babel compilation is leaving
// in the const statements which causes Safari 9 and mobile Safari 7-8 to throw
// errors, so this just converts the consts and lets to vars
function elementClosestPolyfill(window) {
  var ElementPrototype = window.Element.prototype;

  if (typeof ElementPrototype.matches !== 'function') {
    ElementPrototype.matches =
      ElementPrototype.msMatchesSelector ||
      ElementPrototype.mozMatchesSelector ||
      ElementPrototype.webkitMatchesSelector ||
      function matches(selector) {
        var element = this;
        var elements = (
          element.document || element.ownerDocument
        ).querySelectorAll(selector);
        var index = 0;

        while (elements[index] && elements[index] !== element) {
          ++index;
        }

        return Boolean(elements[index]);
      };
  }

  if (typeof ElementPrototype.closest !== 'function') {
    ElementPrototype.closest = function closest(selector) {
      let element = this;

      while (element && element.nodeType === 1) {
        if (element.matches(selector)) {
          return element;
        }

        element = element.parentNode;
      }

      return null;
    };
  }
}
elementClosestPolyfill(window);

// polyfill for Internationalization APIs to support
// react-intl in older browsers
if (!global.Intl) {
  global.Intl = require('intl');
  require('intl/locale-data/jsonp/en.js');
}
